import { Box, Button, Card, CardBody, Flex, Grid, GridItem, Icon, Image, Separator, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import BaseDialog from '../../../components/BaseDialog';
import useDeleteMailbox from '../hooks/useDeleteMailbox';
import { IoMdClose } from "react-icons/io";
import { IMailbox } from '../types';
import { MAILBOXES } from '@/api/queries';

interface IDeleteMailboxProps {
    mailbox: IMailbox;
}

const DeleteMailboxDialog = ({ mailbox }: IDeleteMailboxProps) => {
    const [dialogOpen, setDialogOpen] = useState(false)

    const { deleteMailbox } = useDeleteMailbox();

    const handleDeleteMailbox = async () => {
        const res = await deleteMailbox({mailboxId: mailbox.id});
        res && setDialogOpen(false);
    }

    return (
        <BaseDialog
            open={dialogOpen}
            setOpen={setDialogOpen}
            trigger={
                <Icon size='md' cursor='pointer'>
                    <IoMdClose />
                </Icon>
            }
            title={`Mailbox: ${mailbox.email}`}
            actionButtons={
                <Flex gap={2}>
                    <Button variant="outline" onClick={() => setDialogOpen(false)}>Close</Button>
                    <Button colorPalette='brand' onClick={() => handleDeleteMailbox()}>Confirm</Button>
                </Flex>
            }
        >
            <VStack height={200} justifyContent='center' gap={2}>
                <Text fontSize={'2xl'}>Delete mailbox</Text>
                <Text>Are you sure about deleting?</Text>
            </VStack>
        </BaseDialog>
    )
}

export default DeleteMailboxDialog;